import gql from 'graphql-tag';
import ListingFragments from '../fragments/listing.fragments';

const CREATE_LISTING = gql`
  mutation CreateListing($params: ListingParams!) {
    createListing(params: $params) {
      ...ListingFields
      ...ListingAddress
      ...ListingPortfolioAddresses
      ...ListingSchedule
      ...ListingMedia
      ...ListingGuidance
      ...ListingVault
      ...ListingLicense
      ...ListingMetrics
      ...ListingMeta
      ...ListingUser
      ...ListingContacts
      ...ListingDealProfile
    }
  }

  ${ListingFragments.fields}
  ${ListingFragments.address}
  ${ListingFragments.portfolioAddresses}
  ${ListingFragments.schedule}
  ${ListingFragments.media}
  ${ListingFragments.guidance}
  ${ListingFragments.vault}
  ${ListingFragments.license}
  ${ListingFragments.metrics}
  ${ListingFragments.meta}
  ${ListingFragments.user}
  ${ListingFragments.contacts}
  ${ListingFragments.dealProfile}
`;

export default CREATE_LISTING;
